import { render } from "./page.vue?vue&type=template&id=19c3c382&scoped=true&ts=true"
import script from "./page.vue?vue&type=script&lang=ts"
export * from "./page.vue?vue&type=script&lang=ts"

import "./page.vue?vue&type=style&index=0&id=19c3c382&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c3c382"]])

export default __exports__